import { useTranslation } from '@thoughtspot/i18n';
import { ThemedImage } from '@thoughtspot/radiant-react/widgets/themed-image';
import React from 'react';
import { Horizontal } from '../../utils/layouts';
import styles from './footer.module.scss';
import { FooterProps } from './interfaces';

export const Footer: React.FC<FooterProps> = ({ footerText }: FooterProps) => {
    const { t } = useTranslation();

    return (
        <Horizontal className={styles.footerContainer}>
            <span className={styles.footerText}>{footerText}</span>
            <ThemedImage
                className={styles.footerLogo}
                src="/resources/img/logo/TS-PoweredBy-Black.svg"
                srcDark="/resources/img/logo/TS-PoweredBy-Black_dark.svg"
                alt={t('EmbedDev.Home.BannerHeadII')}
            />
        </Horizontal>
    );
};
